import styled from "styled-components"
import { Grid } from "@mui/material"

export const InnerColumns = styled(Grid)`
  .MuiGrid-root {
    padding-right: 8px;
    padding-left: 8px;

    .gatsby-image-wrapper {
      min-height: 140px;
      max-height: 140px;
    }

    .no-reverse {
      margin: auto 0 auto auto;
    }

    a {
      text-decoration: none;
      color: #000000;
    }
  }
`

export const Wrapper = styled.div`
  max-width: 280px;
`

export const Flex = styled.div`
  display: flex;

  h2 {
    margin-right: 0.25em;
    width: calc(100% - 80px);
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    line-height: ${({ theme }) => theme.typography.pxToRem(26)};
  }

  p {
    width: 80px;
    margin-top: 0;
    margin-bottom: 0;
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    line-height: ${({ theme }) => theme.typography.pxToRem(26)};
  }
`

export const Description = styled.div`
  p,
  ul {
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  }

  p {
    margin-top: 0;
    margin-bottom: 0.5em;
  }

  ul {
    list-style: none;
    padding-left: 0.5em;

    li:only-child {
      margin-left: -0.5em;
    }
  }
`

export const Spacer = styled(Grid)`
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`

export const Dash = styled.div`
  height: 1px;
  width: 90%;
  background-color: #ebebeb;
`
